// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class RefreshTokenMesage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_REFRESH_TOKEN, fieldSet);
    }
    SetRefreshToken(token) {
        this.setFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN, token);
    }
    GetRefreshToken() {
        return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN);
    }
    GetAccessToken() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN);
    }
    GetAccessTokenLifeTime() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN_LIFE_TIME);
    }
    GetRefreshTokenLifeTime() {
        return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN_LIFE_TIME);
    }
}
